import { MapPin, Phone, Mail } from "lucide-react";
import logo from "@/assets/armando-logo.webp";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Calcola l'offset per tenere conto dell'header
      const headerHeight = 80; // h-20 = 80px
      const elementTop = element.offsetTop;
      const offsetPosition = elementTop - headerHeight - 20; // 20px extra di padding
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <footer className="bg-primary text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold">Contatti Ristorante</h4>
            <address className="space-y-3 text-sm not-italic">
              <div className="flex items-center space-x-3">
                <MapPin className="text-gold flex-shrink-0" size={16} />
                <span>Via Aganoor Pompili, 25<br />06065 Passignano sul Trasimeno (PG)</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="text-gold flex-shrink-0" size={16} />
                <a href="tel:+390753880397">+39 075 388 0397</a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="text-gold flex-shrink-0" size={16} />
                <a href="mailto:Mullaxhirela@gmail.com">Mullaxhirela@gmail.com</a>
              </div>
            </address>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold">Orari Apertura</h4>
            <div className="space-y-3 text-sm">
              <div>
                <div className="font-medium text-gold mb-1">🌞 Estate (7/7 + Gio pomeriggio)</div>
                <time className="block">Lun-Dom: 12:00-15:00 | 19:00-23:00</time>
                <time className="block">Giovedì: Solo sera 19:00-23:00</time>
              </div>
              <div>
                <div className="font-medium text-gold mb-1">❄️ Inverno (6/7 - Gio chiuso)</div>
                <time className="block">Lun-Mer, Ven-Dom: 12:00-15:00 | 19:00-23:00</time>
                <div>Giovedì: Chiuso</div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <nav>
            <h4 className="text-lg font-semibold mb-6 text-gold">Link Rapidi</h4>
            <div className="space-y-3 text-sm">
              <button onClick={() => scrollToSection("menu")} className="block hover:text-gold transition-colors text-left">
                Il Nostro Menu
              </button>
              <button onClick={() => scrollToSection("chi-siamo")} className="block hover:text-gold transition-colors text-left">
                Chi Siamo
              </button>
              <button onClick={() => scrollToSection("dove-siamo")} className="block hover:text-gold transition-colors text-left">
                Come Raggiungerci
              </button>
              <button onClick={() => scrollToSection("contatti")} className="block hover:text-gold transition-colors text-left">
                Prenotazioni
              </button>
              <a href="/privacy-policy" className="block hover:text-gold transition-colors">
                Privacy Policy
              </a>
              <a href="/cookie-policy" className="block hover:text-gold transition-colors">
                Cookie Policy
              </a>
              <a href="/termini-condizioni" className="block hover:text-gold transition-colors">
                Termini e Condizioni
              </a>
              <a href="/disclaimer" className="block hover:text-gold transition-colors">
                Disclaimer
              </a>
            </div>
          </nav>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20 py-6">
        <div className="container-custom space-y-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-4">
              <img src={logo} alt="Da Armando" className="h-10 w-auto" />
              <p className="text-sm text-white/80">
                © {currentYear} DA ARMANDO S.R.L. — Tutti i diritti riservati.
              </p>
            </div>
            <div className="text-sm text-white/80 text-center md:text-right">
              <span>Amministratrice Unica: Mulla Xhirela</span>
            </div>
          </div>
          <div className="text-xs text-white/70 text-center leading-relaxed border-t border-white/10 pt-4">
            <p>
              <strong>DA ARMANDO S.R.L.</strong> — Sede legale: Via Aganoor Pompili, 25, 06065 Passignano sul Trasimeno (PG)
            </p>
            <p className="mt-1">
              P.IVA / C.F. e n. iscr. Registro Imprese: 03963890540 • REA: PG-368050 • Capitale sociale: € 4.800,00 i.v.
            </p>
            <p className="mt-1">
              PEC: <a href="mailto:daarmando@pec.it" className="hover:text-gold">daarmando@pec.it</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 